import produce from "immer";

import { Action, actionCreators } from "../actions";

const initialStore = {
    isSearchingRoster: false,
    searchTerm: "",
};
type Store = Readonly<typeof initialStore>;

export const update = produce((draft, action: Action): Store | void => {
    if (
        action.type === actionCreators.onLogout.type ||
        action.type === actionCreators.onWrongToken.type
    ) {
        return initialStore;
    }
    if (action.type === actionCreators.updateTopSearchInput.type) {
        draft.searchTerm = action.value;
    } else if (action.type === actionCreators.rosterSearchOn.type) {
        draft.isSearchingRoster = true;
    } else if (action.type === actionCreators.rosterSearchOff.type) {
        draft.isSearchingRoster = false;
        draft.searchTerm = "";
    }
}, initialStore);

export type OuterStore = { rosterSearch: Store };

export function getRosterSearchTerm(store: OuterStore) {
    return store.rosterSearch.searchTerm;
}

export function getIsSearchingRoster(store: OuterStore) {
    return store.rosterSearch.isSearchingRoster;
}
